import { Headline } from './Headline'
import { Container } from './Container'
import { Column, Grid } from './Grid'
import { imageLoader } from '@/loaders/index'
import forms from '@/public/images/forms.png'
import ellipse from '@/public/images/ellipse.png'
import Image from 'next/image'

export function BlackSectionDark({
  className = ''
}) {
  return (
    <section className={`${className} bg-[#141B24]`}>
      <Container>
        <Grid className="py-[90px] md:py-[106px] items-end relative flex-col md:flex-row">
          <Column className="text-white md:w-[70%]">
            <Headline tag="h2" color="white" className="text-[40px] md:text-[56px] leading-[1.1] mb-[30px]">Double Your Entrepreneurial <br/> Effectiveness <em className='font-accent font--primary text-[46px] md:text-[60px]'>Overnight</em>.</Headline>
            <p className="text-[24px] md:text-[34px] leading-[1.1] font-thin mb-[60px]">(Without Sacrificing Your <br className="hidden md:block"/> Freedom Or Creativity)</p>
            <p className="max-w-[440px] font--primary text-[18px]">Discover the productivity & planning method Commit Action uses to coach thousands of entrepreneurs to amazing results, from doubling revenue, to building businesses that run on autopilot so they can work just a few hours a week.</p>
          </Column>
          <Column className="md:w-[30%] mt-[30px] md:mt-0">
            <Image
              src={forms}
              alt="Forms"
              loader={imageLoader}
            />
          </Column>
          <div className="absolute top-0 left-[100px] md:right-[160px] w-[850px] z-[-1]">
            <Image
              src={ellipse}
              alt="Ellipse decor"
              loader={imageLoader}
            />
          </div>
        </Grid>
      </Container>
    </section>
  )
}
